// extracted by mini-css-extract-plugin
export default {"answer":"styles_answer__gbW+5","selected":"styles_selected__729c5"};